import { handleActions } from 'redux-actions';
import { IGlobalStore, IUser, IAction } from 'models/global';
import { CRM_URL_MAP, LoginStatus } from 'constants/global';
// eslint-disable-next-line import/no-extraneous-dependencies
import update from 'immutability-helper';
import {
  UPDATE_USER_INFO,
  UPDATE_USER_ROLE,
  UPDATE_AUTHORITY,
  UPDATE_PERMISSION,
  UPDATE_MENU,
  UPDATE_CONFIG_DICTS,
  UPDATE_AD_ACCOUNT_INFO,
  USR_LOGIN_SUCCESS,
  USR_LOGOUT_SUCCESS,
  UPDATE_CURRENCY,
  UPDATE_CURRENCY_CONFIG,
  UPDATE_HEADER_BADGE_COUNT,
  UPDATE_HEADER_MSG,
  UPDATE_CENTER_MSG,
  UPDATE_FUND_IDS,
  UPDATE_TIMEZONE,
  UPDATE_ADVERT_SKAN,
  UPDATE_ADVERT_FORM_STEP,
  UPDATE_COMMON_SPINNING,
  UPDATE_COMMON_DELAY_EVENTS,
  UPDATE_ADVERT_CONFIRM_PRE,
  UPDATE_COMMON_ONLY_SPINNING,
  UPDATE_PEAR_CONFIG_DICTS,
} from './action';

export const globalState: IGlobalStore = {
  status: LoginStatus.NOLOGIN,
  userInfo: {},
  userRole: {},
  authority: [],
  permission: [],
  navMenu: [],
  utcOffset: 0, // 用户所在时区的utc偏移量
  configDicts: {
    // 系统字典数据
    language: [],
    location: [],
    interest: [],
    media_app: [],
    age: [],
    android_versions: [],
    max_android_versions: [],
    ios_versions: [],
    max_ios_versions: [],
    ad_category: [],
    operation: [],
    gender: [],
    media_rules: {},
    valid_optimization_goal: [],
    valid_place_id: { imo: [] },
    valid_pricing_type: [],
    max_exclude_custom_audience: 5,
    max_include_custom_audience: 5,
    min_lookalike_user_count: 1000, // 可扩展的人群包的规模下限
    country: [],
    advanced_creative_country: [],
    supportedThirdPartnerMonitor: [],
    aeo_event_days: 0, // AEO应用内事件显示的是几天内回传的信息
    material_limit: {
      action: 0,
      creative: 0,
      primary: 0,
    },
    // 高级创意优惠券类型磁贴需要的货币数据
    currency: [
      {
        symbol: '',
        code: '',
      },
    ],
    first_classification: {},
    second_classification: {},
    app_classification_map: {},
    looklike_media_app: [],
    deep_cvt_goal: {},
    limit_ad_num: 0,
    ad_max_for_account_day: 0,
    canUseSkan: false, // 是否可以使用skan
    /** iphone机型列表 */
    lowest_ios_model_versions: [],
    /** 浅层目标出价/深层目标出价比值 */
    doubleBidRatio: 0.6,
    prog_adset_limit: 100,
    oldLocation: [],
    /** 可投非谷歌应用商店的国家 */
    spec_store_support_region: [],
    /** 默认可以投放的应用商店域名  */
    common_store_domain: [],
    /** 三星、华为、ru等可以投放的应用商店域名 */
    spec_store_domain: [],
  },
  // targetControl: {
  //   interest: 0, // 是否处于兴趣定向的白名单中，下同
  //   appDownload: 0, // apk落地页推广
  //   pixel: 0, // 是否开放pixel相关功能
  //   material: 0, // 是否开放素材库相关功能
  //   customAudience: 0, // 是否开放受众管理相关功能
  //   othersMonitor: 0, // 应用管理三方监测是否可选others
  //   deeplink: 0, // 是否开放广告组设置deeplink
  //   customAudienceUpdate: 0, // 是否开放人群包更新功能
  // },
  adAccountInfo: {},
  currency: '',
  currencyConfig: {},
  headerBadgeCount: 0, // 未读消息数
  headerMsg: [], // 页面头部的消息数据
  centerMsg: [], // 消息中心中的消息数据
  fundIds: [], // 新功能权限点
  timezone: '', // 当前时区
  skan: {}, // 广告投放模块需要的数据
  advertFormStep: 1, // 广告投放模块-新建表单当前展示的表单
  spinning: false,
  onlySpinning: false,
  delayedEvents: {}, // 全局事件派发，和通用事件模型的区别是，这里是延迟消费的
  advertConfirmPre: {}, // 广告表单二次确认弹框结果缓存
  // pear中配置的字典值
  pearConfigDicts: { crmUrlMap: CRM_URL_MAP },
};

const userReducer = handleActions(
  {
    [UPDATE_USER_INFO](state, { payload }: IAction<{ userInfo: IUser }>) {
      return update(state, {
        userInfo: {
          $set: payload,
        },
      });
    },
    [UPDATE_USER_ROLE](state, { payload }: IAction) {
      return update(state, {
        userRole: {
          $set: payload,
        },
      });
    },
    [UPDATE_AUTHORITY](state, { payload }: IAction) {
      return update(state, {
        authority: {
          $set: payload,
        },
      });
    },
    [UPDATE_PERMISSION]: (state: IGlobalStore, { payload }: IAction) => {
      return update(state, {
        permission: {
          $set: payload,
        },
      });
    },
    [UPDATE_MENU](state, { payload }: IAction) {
      return update(state, {
        navMenu: {
          $set: payload,
        },
      });
    },
    [UPDATE_CONFIG_DICTS](state, { payload }: IAction) {
      return update(state, {
        configDicts: {
          $set: payload,
        },
      });
    },
    [UPDATE_AD_ACCOUNT_INFO](state, { payload }: IAction) {
      return update(state, {
        adAccountInfo: {
          $set: payload,
        },
        utcOffset: {
          $set: payload.timezone,
        },
      });
    },

    [USR_LOGIN_SUCCESS]: (state, { payload }: IAction) => {
      return update(state, {
        status: {
          $set: LoginStatus.LOGINED,
        },
      });
    },
    [USR_LOGOUT_SUCCESS]: (state, { payload }: IAction) => {
      return update(state, {
        status: {
          $set: LoginStatus.NOLOGIN,
        },
      });
    },

    [UPDATE_HEADER_BADGE_COUNT]: (state, { payload }: IAction) => {
      return update(state, {
        headerBadgeCount: {
          $set: payload,
        },
      });
    },
    [UPDATE_CURRENCY](state, { payload }: IAction) {
      return update(state, {
        // @ts-ignore
        currency: {
          $set: payload,
        },
      });
    },
    [UPDATE_CURRENCY_CONFIG](state, { payload }: IAction) {
      return update(state, {
        // @ts-ignore
        currencyConfig: {
          $set: payload,
        },
      });
    },
    [UPDATE_HEADER_MSG]: (state, { payload }: IAction) => {
      return update(state, {
        headerMsg: {
          $set: payload,
        },
      });
    },
    [UPDATE_CENTER_MSG]: (state, { payload }: IAction) => {
      return update(state, {
        centerMsg: {
          $set: payload,
        },
      });
    },
    [UPDATE_FUND_IDS]: (state, { payload }: IAction) => {
      return update(state, {
        fundIds: {
          $set: payload,
        },
      });
    },
    [UPDATE_TIMEZONE]: (state, { payload }: IAction) => {
      return update(state, {
        timezone: {
          $set: payload,
        },
      });
    },
    [UPDATE_ADVERT_FORM_STEP]: (state, { payload }: IAction) => {
      return update(state, {
        advertFormStep: {
          $set: payload,
        },
      });
    },
    [UPDATE_ADVERT_SKAN]: (state, { payload }: IAction<IGlobalStore['skan']>) => {
      return update(state, {
        skan: {
          $set: { ...state.skan, ...payload },
        },
      });
    },
    [UPDATE_COMMON_SPINNING]: (state, { payload }: IAction<IGlobalStore['spinning']>) => {
      return update(state, { spinning: { $set: payload } });
    },
    [UPDATE_COMMON_ONLY_SPINNING]: (state, { payload }: IAction<IGlobalStore['spinning']>) => {
      return update(state, { onlySpinning: { $set: payload } });
    },
    [UPDATE_COMMON_DELAY_EVENTS]: (state, { payload }: IAction<IGlobalStore['delayedEvents']>) => {
      return update(state, { delayedEvents: { $set: payload } });
    },
    [UPDATE_ADVERT_CONFIRM_PRE]: (state, { payload }: IAction<IGlobalStore['advertConfirmPre']>) => {
      return update(state, { advertConfirmPre: { $set: payload } });
    },
    [UPDATE_PEAR_CONFIG_DICTS]: (state, { payload }: IAction<IGlobalStore['pearConfigDicts']>) => {
      return update(state, { pearConfigDicts: { $set: payload } });
    },
  },
  globalState
);

export default userReducer;
